import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { Location } from '@angular/common';
import { DatabaseService } from 'src/_services/DatabaseService';
import { ToastrManager } from 'ng6-toastr-notifications';

@Component({
  selector: 'app-leave-master-ledger',
  templateUrl: './leave-master-ledger.component.html',
  styleUrls: ['./leave-master-ledger.component.scss']
})
export class LeaveMasterLedgerComponent implements OnInit {
  skLoading: boolean = false;
  getData: any;
  constructor(@Inject(MAT_DIALOG_DATA) public data,public location: Location,public service: DatabaseService,public toast: ToastrManager,public dialogRef: MatDialogRef<LeaveMasterLedgerComponent>) {
  
    console.log(data)
    this.getLedger()
   }

  ngOnInit() {
  }

  back(): void {
    this.dialogRef.close();
  }
  getLedger()
  {
    this.skLoading = true;
    this.service.post_rqst({'userId': this.data.user_id},"leaves/leaveCountLogs").subscribe((result=>
      {
        
        if(result['statusCode'] == 200){
          this.getData = result.leaveLogs;
          console.log( this.getData,"line 58")
          this.skLoading = false;
        }
        else{
          this.toast.errorToastr(result['statusMsg']);
          this.skLoading = false;
        }
      }
      ));
      
    }
  

}
